import React, { useState } from "react";

import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";

import { postUser } from "../../services/admin";

import { selectToken } from "../../storeConfig/reducers/loginReducer";
import { useSelector } from "react-redux";
import { useQueryClient } from '@tanstack/react-query'

function CadastroAdmin() {
    const token = useSelector(selectToken);
	const queryClient = useQueryClient()

	const [response, setResponse] = useState("");

	const [email, setEmail] = useState("");
	const [tipo, setTipo] = useState(3);

	const [error, setError] = useState({
		email: false,
	});

	const [helperText, setHelperText] = useState({
		email: false,
	});

	const handleChange = (e) => {
		setTipo(parseInt(e.target.value));
	};

	const validateHelperText = (errors) => { 
		console.log(errors);

		setHelperText({
			nome_usuario: errors.nome_usuario,
			email: errors.email,
		});
	};

	const validateError = (errors) => { 
		console.log(errors);

		let aux = {
			nome_usuario: errors.nome_usuario ? true : false,
			email: errors.email ? true : false,
		};

		setError(aux);
	};

	const postNovoUsuario = () => {
		const novo_usuario = {
			email: email,
			usuario_admin: 		 tipo === 1,
			// usuario_gestor: 	 tipo === 2, 
			usuario_usuario: 	 tipo === 3, 
		};

		postUser(token, novo_usuario)
			.then(function (response) {
				setResponse(response.data.response);
				setEmail("");
				setTipo(3);

				setHelperText({
					email: "",
				});

				setError({
					email: false,
				});

				queryClient.invalidateQueries(["get-users-admin"]);
			})
			.catch(function (error) {
				validateHelperText(error.response.data);
				validateError(error.response.data);

				console.log(error);
			});
	};

	return (
		<div className="row d-flex justify-content-center">
			<div className="col-sm-6">
				<h2>Cadastrar</h2>
				<hr />

				<TextField
					className="mb-3"
					fullWidth
					label="E-mail"
					error={error.email}
					helperText={helperText.email}
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/> 

				<FormControl>
					<FormLabel className="my-2">Tipo do Usuário</FormLabel>
					<RadioGroup value={tipo} onChange={handleChange} required>
						<FormControlLabel
							control={<Radio />}
							value={1}
							label="Admin"
						/>
						{/* <FormControlLabel
							control={<Radio />}
							value={2}
							label="Gestor"
						/> */}
						<FormControlLabel
							control={<Radio />}
							value={3}
							label="Usuário"
						/>
					</RadioGroup>

					<Button
						className="mt-3"
						type="submit"
						variant="contained"
						onClick={postNovoUsuario}
					>
						Enviar
					</Button>
				</FormControl>

				{response !== "" &&
					error.nome_usuario === false &&
					error.email === false && (
						<Alert
							className="mt-3"
							severity="success"
							onClose={() => {
								setResponse("");
							}}
						>
							{response}
						</Alert>
					)}
			</div>
		</div>
	);
}

export default CadastroAdmin;
